<template>
  <span class="stepper-wrapper">
    <input
      class="stepper-input form-control"
      :class="inputClass || 'input-sm'"
      v-bind="$attrs"
      :value="_innerValue"
      @input="onChange($event.target.value)"
    >
    <div class="stepper-btn-wrap">
      <i
        class="stepper-btn-up typcn typcn-arrow-sorted-up p-0"
        title="Increase"
        @click="increase"
      />
      <i
        class="stepper-btn-dwn typcn typcn-arrow-sorted-down p-0"
        title="Decrease"
        @click="decrease"
      />
    </div>
  </span>
</template>

<script>

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NumberStepperInput',
  emits: ['input'],
  props: {
    value: {
      type: Number,
      default: 0,
    },
    inputClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      _innerValue: this.value,
    };
  },
  methods: {
    onChange(newValue) {
      let nextValue = typeof newValue === 'number'
        ? newValue
        : parseInt(newValue.replace(/\D/g, ''), 10);

      // check if hte input can be parsed correctly
      if (isNaN(nextValue) || nextValue === this._innerValue) {
        return;
      }

      // attributes values are string so should be parsed to numbers
      let { max, min } = this.$attrs;
      max = max ? parseInt(max, 10) : Infinity;
      min = min ? parseInt(min, 10) : -Infinity;

      nextValue = Math.min(max, Math.max(min, nextValue));

      // check again after clamping
      if (nextValue === this._innerValue) {
        return;
      }

      this._innerValue = nextValue;
      this.$emit('input', nextValue);
    },
    increase() {
      this.onChange(this._innerValue + 1);
    },
    decrease() {
      this.onChange(this._innerValue - 1);
    },
  },
  watch: {
    value: {
      handler: function (newValue) {
        this._innerValue = newValue;
      },
      immediate: true,
    },
  }
});

</script>

<style lang="scss">

// See app/styles/modules/_number_stepper.scss

</style>
